import { ARColzaCampaign, ARColzaOrder, ARColzaOrderItem } from '../../../../models/agrorendement-colza.model';
import { correctDate } from '../../../../utils/utils';
import { KeycloakService } from '../../../../services/keycloak.service';

export class ARColzaUtils {
  public static isOrderEditable(order: ARColzaOrder): boolean {
    const isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    const today = correctDate(new Date());
    const campaign = order.campaign;
    const config = campaign.configuration;

    // si non admin => false
    if (!isAdmin) {
      return false;
    }
    // si fin EH pas définie => OK
    if (config.endingOnEh === null) {
      return true;
    }
    // si commande créée avant fin EH :
    // test si today est avant EH
    // sinon la commande nep eut être modifiable
    if (order.createdAt <= config.endingOnEh) {
      return today <= config.endingOnEh;
    }
    // commande créée après fin EH
    if (config.endingOnSh === null) {
      return true;
    }
    // fin SH existe : on doit être avant fin SH
    return today <= config.endingOnSh;
  }

  public static isCampaignCurrentlyOpen(campaign: ARColzaCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return config.startingOn <= today && (config.endingOnSh === null || config.endingOnSh >= today);
  }

  public static isColzaEHEnded(campaign: ARColzaCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return config.startingOn <= today && !!config.endingOnEh && config.endingOnEh <= today;
  }

  public static canBeOrdered(orderItem: ARColzaOrderItem, hasOpenedCampaign: boolean): boolean {
    // TODO implémenter ces conditions sur le serveur
    return orderItem && !orderItem.order && hasOpenedCampaign;
  }
}
